/**
 * Feriados nacionales del Perú.
 *
 * Se escriben en formato YYYY-MM-DD para que el mes vaya tal cual y no con el
 * índice base cero de `Date`, que es la fuente habitual de errores al mantener
 * la lista.
 *
 * Los feriados fijos se repiten todos los años. Jueves y Viernes Santo son
 * móviles, así que hay que agregar cada año a mano antes de que se acabe el
 * último listado aquí.
 */
export const PERU_HOLIDAY_DATES: string[] = [
  // Año 2026
  '2026-01-01', // Año Nuevo
  '2026-04-02', // Jueves Santo
  '2026-04-03', // Viernes Santo
  '2026-05-01', // Día del Trabajo
  '2026-06-07', // Batalla de Arica y Día de la Bandera
  '2026-06-29', // San Pedro y San Pablo
  '2026-07-23', // Día de la Fuerza Aérea del Perú
  '2026-07-28', // Fiestas Patrias
  '2026-07-29', // Fiestas Patrias
  '2026-08-06', // Batalla de Junín
  '2026-08-30', // Santa Rosa de Lima
  '2026-10-08', // Combate de Angamos
  '2026-11-01', // Día de Todos los Santos
  '2026-12-08', // Inmaculada Concepción
  '2026-12-09', // Batalla de Ayacucho
  '2026-12-25', // Navidad

  // Año 2027
  '2027-01-01', // Año Nuevo
  '2027-03-25', // Jueves Santo
  '2027-03-26', // Viernes Santo
  '2027-05-01', // Día del Trabajo
  '2027-06-07', // Batalla de Arica y Día de la Bandera
  '2027-06-29', // San Pedro y San Pablo
  '2027-07-23', // Día de la Fuerza Aérea del Perú
  '2027-07-28', // Fiestas Patrias
  '2027-07-29', // Fiestas Patrias
  '2027-08-06', // Batalla de Junín
  '2027-08-30', // Santa Rosa de Lima
  '2027-10-08', // Combate de Angamos
  '2027-11-01', // Día de Todos los Santos
  '2027-12-08', // Inmaculada Concepción
  '2027-12-09', // Batalla de Ayacucho
  '2027-12-25', // Navidad

  // Año 2028
  '2028-01-01', // Año Nuevo
  '2028-04-13', // Jueves Santo
  '2028-04-14', // Viernes Santo
  '2028-05-01', // Día del Trabajo
  '2028-06-07', // Batalla de Arica y Día de la Bandera
  '2028-06-29', // San Pedro y San Pablo
  '2028-07-23', // Día de la Fuerza Aérea del Perú
  '2028-07-28', // Fiestas Patrias
  '2028-07-29', // Fiestas Patrias
  '2028-08-06', // Batalla de Junín
  '2028-08-30', // Santa Rosa de Lima
  '2028-10-08', // Combate de Angamos
  '2028-11-01', // Día de Todos los Santos
  '2028-12-08', // Inmaculada Concepción
  '2028-12-09', // Batalla de Ayacucho
  '2028-12-25', // Navidad
];

/**
 * Los mismos feriados como `Date` en hora local y a las 00:00.
 *
 * Se parsean por partes a propósito: `new Date('2026-08-06')` se interpreta como
 * medianoche UTC y en Lima (UTC-5) termina siendo el día anterior.
 */
export const PERU_HOLIDAYS: Date[] = PERU_HOLIDAY_DATES.map(toLocalDate);

/** Indica si la fecha cae en un feriado nacional. */
export function isPeruHoliday(date: Date): boolean {
  const day = new Date(date);
  day.setHours(0, 0, 0, 0);

  return PERU_HOLIDAYS.some((holiday) => holiday.getTime() === day.getTime());
}

function toLocalDate(value: string): Date {
  const [year, month, day] = value.split('-').map(Number);

  return new Date(year, month - 1, day);
}
